import {IErrorTrace} from '../../api/interfaces/ApplicationError/IErrorTrace';
import { RequestMethod} from '@angular/http';

export class HttpErrorTrace implements IErrorTrace {
  method: string;
  requestData?: object;
  responseData: object;
  url: string;

  constructor (method: RequestMethod, requestData: object, responseData: object = {}, url: string ) {
    this.method = RequestMethod[method.toString()];
    this.requestData = requestData;
    this.responseData = responseData;
    this.url = url;
  }

  toString() {
    return JSON.stringify(this);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/error/http.error.trace.ts